/** Datadog sites. `domain` is the site parameter that Datadog's API hosts
 * (`api.<domain>`) and MCP hosts (`mcp.<domain>`) are built from. */
export const DatadogSites = {
  us1: { label: "US1", domain: "datadoghq.com" },
  us3: { label: "US3", domain: "us3.datadoghq.com" },
  us5: { label: "US5", domain: "us5.datadoghq.com" },
  eu1: { label: "EU1", domain: "datadoghq.eu" },
  ap1: { label: "AP1", domain: "ap1.datadoghq.com" },
  ap2: { label: "AP2", domain: "ap2.datadoghq.com" },
  "us1-fed": { label: "US1-FED", domain: "ddog-gov.com" },
} as const satisfies Record<string, { label: string; domain: string }>;

export type DatadogSite = keyof typeof DatadogSites;
